module.exports = __webpack_public_path__ + "static/media/stat547u_lecture09.0b9f6eed.pdf";